"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _uuid = require("uuid");
var _utils = require("@trs/utils");
var _config = require("@trs/config");
var _ShareDetailLegend = _interopRequireDefault(require("./ShareDetailLegend.style"));
var _currency = _interopRequireDefault(require("../currency"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ShareDetailLegend = function ShareDetailLegend(_ref) {
  var shareData = _ref.shareData,
    label = _ref.label,
    employeeCurrency = _ref.employeeCurrency,
    showVested = _ref.showVested,
    showUnvested = _ref.showUnvested;
  return /*#__PURE__*/_react["default"].createElement(_ShareDetailLegend["default"], null, shareData.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: (0, _uuid.v4)(),
      className: "share-legend-item ".concat(item.shareStatus)
    }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_currency["default"], {
      currency: "",
      decimals: _config.MAX_DECIMALS,
      shouldParseFloat: true
    }, item.count), " ".concat(item.shareStatus, " ").concat((0, _utils.toLower)(label.SHARES_PAGE_GROUP), " "), /*#__PURE__*/_react["default"].createElement("span", {
      className: "percentage"
    }, "(".concat(item.value, "%)"))), (item.shareStatus === 'vested' && showVested || item.shareStatus === 'unvested' && showUnvested) && /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_currency["default"], {
      currency: R.path(['amount', 'currency'], item),
      decimals: _config.MAX_DECIMALS,
      shouldParseFloat: true
    }, R.path(['amount', 'value'], item)), ' ', R.path(['amount', 'currency'], item) !== employeeCurrency && /*#__PURE__*/_react["default"].createElement("span", null, "(", /*#__PURE__*/_react["default"].createElement(_currency["default"], {
      currency: R.path(['employeeAmount', 'currency'], item),
      decimals: _config.MAX_DECIMALS,
      shouldParseFloat: true
    }, R.path(['employeeAmount', 'value'], item)), ")")));
  }));
};
ShareDetailLegend.defaultProps = {
  showVested: true,
  showUnvested: true
};
ShareDetailLegend.propTypes = {
  /** List of shares with details */
  shareData: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  label: _propTypes["default"].shape({
    SHARES_PAGE_GROUP: _propTypes["default"].string
  }).isRequired,
  employeeCurrency: _propTypes["default"].string.isRequired,
  showVested: _propTypes["default"].bool,
  showUnvested: _propTypes["default"].bool
};
ShareDetailLegend.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ShareDetailLegend",
  "props": {
    "showVested": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showUnvested": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "shareData": {
      "description": "List of shares with details",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": true
    },
    "label": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "SHARES_PAGE_GROUP": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    },
    "employeeCurrency": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = ShareDetailLegend;
exports["default"] = _default;